import React from 'react';
import { api, config, use } from 'xadmin';
import { C, Icon, Page, Loading } from 'xadmin-ui';
import _ from 'lodash'
import { Button, Modal, Checkbox, Input, Popconfirm, Menu, Form, Layout, Select, DatePicker, message, Row, Col, InputNumber, Tooltip } from 'antd'
import { SchemaForm } from 'xadmin-form';
import LogType from '../LogType'
import YmdwwpsPicker from './YmdwwpsPicker'
import './index.css'
import { HasPermission } from 'xadmin-auth'

const { Content, Sider } = Layout;
const { Option } = Select
const { RangePicker } = DatePicker
const style = {
    width: '100%',
    padding: '10px'
}
const opt = [{ value: 'day', name: '天' }, { value: 'week', name: '周' }, { value: 'month', name: '月' }, { value: 'year', name: '年' }]

const getConfig = (props, active) => {
    const ArchiveSchema = props?.ArchiveSchema
    let _onceSchema = {}, _cycleSchema, cleanAdd, cleanEdit, cleanDelete, deleteQuery, url, onceUrl, query
    if (props?.btnModule == 'warning') {
        if (props.onceSchema && props.cycleSchema) {
            _onceSchema = {
                ...props.onceSchema,
                properties: {
                    ...props.onceSchema.properties,
                    time: { ...props.onceSchema.properties.time, title: '清除时间' },
                    range: { ...props.onceSchema.properties.range, title: '清除范围' },
                    condition: { ...props.onceSchema.properties.condition, title: '清除条件' },
                    type: { ...props.onceSchema.properties.type, title: '报警类型' },
                    hasArchive: {
                        title: '是否同时清除归档报警',
                        type: 'boolean'
                    }
                },
                form: [...props.onceSchema.form, 'hasArchive']
            }
            _cycleSchema = {
                ...props.cycleSchema,
                properties: {
                    ...props.cycleSchema.properties,
                    interval: { ...props.cycleSchema.properties.interval, title: '清除周期' },
                    range: { ...props.cycleSchema.properties.range, title: '清除范围' },
                    condition: { ...props.cycleSchema.properties.condition, title: '清除条件' },
                    type: { ...props.cycleSchema.properties.type, title: '报警类型' },
                    // cycle: cycleSchema.properties.cycle,
                    // time_config: cycleSchema.properties.time_config,
                    hasArchive: {
                        title: '是否同时清除归档报警',
                        type: 'boolean'
                    }
                }
            }
            _cycleSchema.form = ['name', ..._cycleSchema.form.filter(item => item?.key != 'name'), 'hasArchive']
        }
        cleanAdd = active == '一键清除' ? 'warningclean.instant' : 'warningclean.add'
        cleanEdit = 'warningclean.edit'
        cleanDelete = 'warningclean.delete'
        deleteQuery = props.data?.id
        url = 'warning/warningclean'
        onceUrl = 'warning/warningclean/instantDelete'
        query = {
            "limit": 30, "skip": 0, "sort": { "createTime": -1 }, project: {
                condition: 1, cycle: 1, cycle_type: 1, type: 1, hasArchive: 1,
                department: 1, disabled: 1, model: 1, name: 1, range: 1, status: 1, time_config: 1, processed: 1
            }, "withCount": true
        }
    } else if (props?.btnModule == 'instruct') {
        if (ArchiveSchema) {
            _onceSchema = {
                ...onceSchema,
                properties: {
                    time: { ...onceSchema.properties.time, title: '清除时间' },
                    cycle_tyle: { ...ArchiveSchema.properties.cycle_tyle, title: '清除类型' },
                    models: { ...ArchiveSchema.properties.models },
                    node: { ...ArchiveSchema.properties.node },
                    commands: { ...ArchiveSchema.properties.commands },
                    users: { ...ArchiveSchema.properties.users },
                    clean_archive: {
                        title: '是否同时清除归档指令日志',
                        type: 'boolean'
                    }
                },
                form: ['time', 'cycle_tyle', 'models', 'node', 'commands', 'users', 'clean_archive'],
                formEffect: ArchiveSchema.formEffect,
            }

            _cycleSchema = {
                ...cycleSchema,
                properties: {
                    ...ArchiveSchema.properties,
                    cycle: { ...cycleSchema.properties.cycle, title: '清除周期' },
                    time_config: { ...cycleSchema.properties.time_config, title: '清除时间' },
                    cycle_tyle: { ...ArchiveSchema.properties.cycle_tyle, title: '清除类型' },
                    clean_archive: {
                        title: '是否同时清除归档指令日志',
                        type: 'boolean'
                    }
                },
                form: [...ArchiveSchema.form, 'clean_archive'],
                formEffect: ArchiveSchema.formEffect
            }
        }
        cleanAdd = active == '一键清除' ? 'archiveonce.add' : 'cleancycle.add'
        cleanEdit = "cleancycle.edit"
        cleanDelete = 'cleancycle.delete'
        deleteQuery = props.data?.name
        url = 'driver/cleancycle'
        onceUrl = 'driver/cleanonce'
        query = {
            "limit": 30, "skip": 0, "sort": { "createTime": -1 }, project: {
                name: 1, cycle: 1, cycle_type: 1, clean_archive: 1, models: 1, node: 1, users: 1, commands: 1, disabled: 1, time_config: 1,
            }, "withCount": true
        }
    } else {
        _onceSchema = props?.onceSchema || onceSchema
        _cycleSchema = props?.cycleSchema || cycleSchema
        cleanAdd = active == '一键清除' ? (props?.oncePermissionKey ? (props.oncePermissionKey + '.add') : 'archiveonce.add' ) : (props?.cyclePermissionKey ? (props.cyclePermissionKey + '.add') :'cleancycle.add')
        cleanEdit = props?.cyclePermissionKey ? (props.cyclePermissionKey + '.edit') : "cleancycle.edit"
        cleanDelete =props?.cyclePermissionKey ? (props.cyclePermissionKey + '.delete') : 'cleancycle.delete'
        deleteQuery = props?.queryKey ? props.data?.[props.queryKey] : props.data?.name
        url = props?.url || 'log-clean/cleancycle'
        onceUrl = props?.onceUrl || 'log-clean/cleanonce'
        query = props?.query || { "limit": 30, "skip": 0, "sort": { "createTime": -1 }, "withCount": true }
    }
    return { onceSchema: _onceSchema, cycleSchema: _cycleSchema, cleanAdd, cleanEdit, cleanDelete, deleteQuery, url, onceUrl, query }
}

const TableTile = (props) => {
    const { title, data, setState, setActive, setSearchArr, getCycles } = props
    const { deleteQuery, url, cleanEdit, cleanDelete } = getConfig({ ...props, data })

    const getMessage = () => {
        api({ name: url }).fetch('/' + deleteQuery, {}).then(({ json }) => {
            json.cycle = {
                cycle: json?.cycle,
                cycle_type: json?.cycle_type
            }
            setState(json)
        })
    }

    const onDisable = () => {
        api({ name: url }).fetch('/' + deleteQuery, {
            method: 'PATCH',
            body: JSON.stringify({ ...data, disabled: !data.disabled })
        }).then((arg) => {
            const { json } = arg
            if (arg.status == 200) {
                message.success('修改成功')
                data.disabled = !data.disabled
                setSearchArr(arr => _.cloneDeep(arr))
                // if (props.btnModule == 'warning') { getMessage() } else { setState({ ...json }) }
            } else {
                message.error(arg.message)
            }
        }).catch(err => {
            message.error(JSON.parse(err.message).item,err?.detail)
        })
    }

    const onDelete = () => {
        api({ name: url }).fetch('/' + deleteQuery, {
            method: 'DELETE'
        }).then((arg) => {
            if (arg.status == 200) {
                message.success('删除成功')
                setState({})
                setActive(null)
                getCycles()
            } else {
                message.error(arg.message,arg?.detail)
            }
        }).catch(err => {
            message.error(JSON.parse(err.message).item,err?.detail)
        })
    }

    return <div style={{ width: '16rem', display: 'flex', justifyContent: 'space-between' }}>
        <span>{title}</span>
        <span style={{ marginRight: 50 }}>
            {cleanEdit ? <HasPermission permission={cleanEdit}>
                <Popconfirm
                    title={!data.disabled ? "确定禁用此项?" : "确定启用此项?"}
                    onConfirm={onDisable}
                    onCancel={() => { }}
                    okText="确定"
                    cancelText="取消"
                >
                    <Icon type="stop" style={{ color: data.disabled ? 'red' : '#36af57' }} />
                </Popconfirm>
            </HasPermission> : null
            }
            {
                cleanDelete ? <HasPermission permission={cleanDelete}>
                    <Popconfirm
                        title="确定删除此项?"
                        onConfirm={onDelete}
                        onCancel={() => { }}
                        okText="确定"
                        cancelText="取消"
                    >
                        <Icon type="delete" />
                    </Popconfirm>
                </HasPermission> : null
            }
        </span>
    </div>
}
const rule = {
    d: 30,
    w: 52,
    m: 12,
    y: null
}
let cycleSchema = {
    type: 'object',
    properties: {
        name: {
            type: 'string',
            title: '周期名称'
        },
        type: {
            title: '日志类型',
            field: {
                type: 'filter_enum',
                component: LogType,
                field: {
                    effect: (f, form) => {
                        const { initialValues } = form.getState()
                        if (initialValues && !_.isEmpty(initialValues)) {
                            if (f.value != initialValues.type) {
                                form.change('time_config', null)
                            }
                        }
                    }
                }
            },
        },
        cycle: {
            type: 'object',
            title: '清除周期',
            // field: { expand: true },
            properties: {
                cycle: {
                    title: '数量',
                    type: 'number',
                    field: {
                        validate: value => {
                            return (/^(0+)|[^\d]+/g.test(value) ? '只能为大于0的正整数' : null)
                        }
                    }
                },
                cycle_type: {
                    title: '日期单位',
                    type: 'string',
                    field: {
                        component: ({ input }) => {
                            return <Select {...input} style={{ maxWidth: '200px' }}>
                                {opt.map(item => <Option value={item.value}>{item.name}</Option>)}
                            </Select>
                        },
                        effect: (f, form) => {
                            const { initialValues } = form.getState()
                            if (initialValues && !_.isEmpty(initialValues)) {
                                if (f.value != initialValues.cycle_type) {
                                    form.change('time_config', null)
                                }
                            }
                        },
                        validate: value => {
                            return !value ? '请选择日期单位' : null
                        }
                    }
                }
            },
            description: "周期定义后，将会按照周期定时清除周期内的日志信息"
        },
        time_config: {
            type: 'object',
            title: '清除时间',
            properties: {},
            field: {
                component: YmdwwpsPicker,
                validate: (value, values) => {
                    const pl = values && values.planCycle || undefined
                    if (JSON.stringify(value) == '{}') return false
                    if (!value || typeof value == 'string') return false
                    if (values.type != 'hms' && values.type != 'minute') {
                        if (value && !value.hms) return '请选择执行时间'
                    }
                    if (pl == 'year') {
                        if (!value.hour) {
                            return '请选择执行月'
                        } else if (!value.day) return '请选择执行日'
                    } else if (pl == 'week') {
                        if (!value.week) return '请选择执行日'
                    } else if (pl == 'month') {
                        if (!value.day) return '请选择执行日'
                    }
                }
            },
            description: '可定义每个周期清除执行时间，不定义默认周期的00:00:00执行'
        },
        clean_archive: {
            title: '是否同时清除归档日志',
            type: 'boolean'
        }
    },
    required: ['name', 'cycle']
    // formEffect: (form) => {
    //     const { initialValues, values } = form.getState()
    //     form.useField('types', state => {
    //         if (initialValues && !_.isEmpty(initialValues)) {
    //             if (state.value != initialValues.types) {
    //                 form.change('time_config', null)
    //             }
    //         }
    //     })
    // }
}
const NumUnit = props => {
    const { input, unit } = props
    return <InputNumber {...input} addonAfter={unit} placeholder='输入数值' />
}
const actionType = {
    type: 'string',
    title: '操作类型',
    enum: ['between', 'retained'],
    enum_title: ['清除数据', '保留数据'],
    description: '操作类型用来定义清除数据的不同操作方式，当执行清除数据时，选择时间范围的数据均被清除，选择保留数据时，定义保留数据的时长，其余数据被清除',
}
const duration = {
    title: '保留数据',
    type: 'number',
    minimum: 1,
    field: {
        unit: '天',
        component: NumUnit,
        validate: (v, vs) => vs.type == 'retained' && _.isNil(v) ? '时间定义不能为空' : null
    }
}

let onceSchema = {
    type: 'object',
    properties: {
        actionType,
        duration,
        type: {
            title: '日志类型',
            field: {
                type: 'filter_enum',
                component: LogType
            }
        },
        time: {
            title: '时间定义',
            field: {
                component: (props) => {
                    const format = 'YYYY-MM-DD HH:mm:ss'
                    const { input: { onChange, value } } = props
                    return <RangePicker allowEmpty={[true, true]} onChange={(time, timeString) => {
                        onChange({ start_time: timeString[0], end_time: timeString[1] })
                    }} format={format} showTime
                        defaultValue={_.isArray(value.time) ? [moment(value.start_time, format), moment(value.end_time, format)] : null}
                        style={{ width: '100%' }} />
                },
                validate: (v, vs) => vs.type == 'between' && !v ? '时间定义不能为空' : null
            },
            description: '可选时间范围或只定义一个时间，定义一个时间默认将定义时间之前的日志清除'
        },
        clean_archive: {
            title: '是否同时清除归档日志',
            type: 'boolean'
        }
    },
    formEffect: form => {
        form.useField('actionType', ({ value }) => {
          form.setFieldData('time', { display: value == 'between', field: { required: value == 'between' } })
          form.setFieldData('duration', { display: value == 'retained', field: { required: value == 'retained' } })
        })
    },
    required: ['time']
}

const Component = (props) => {
    const { onChange, value, setVisible, visible, active, setActive, modelDispatch, saveItem, queryKey } = props
    const [arr, setArr] = React.useState([])
    const [searchArr, setSearchArr] = React.useState([])
    // const [ active, setActive ] = React.useState(null)
    const [state, setState] = React.useState({})
    const [type, setType] = React.useState('一键清除')
    const [loading, setLoading] = React.useState()
    const { onceSchema, cycleSchema, cleanAdd, cleanEdit, url, url: _url, onceUrl, query } = getConfig(props, active)
    const { getModelState } = use('model')
    const { filter: stateFilter } = getModelState()
    const currentValue = React.useRef()

    const ChildrenNode = (props) => {
        let { children, change, invalid, handleSubmit, submitting, onCancel, limits, currentValue, btnModule, formkey } = props
        const { form, values: { name, type } } = use('form', state => ({ values: state && state.values }))

        React.useEffect(() => { cycleSchema.formEffect && cycleSchema.formEffect(form) }, [cycleSchema])

        if (props.errors && Object.keys(props.errors).length == 1 && props.errors.time) invalid = false
        // if (JSON.stringify(type) == '{}') invalid = true

        let warnKey = formkey.substring(formkey.indexOf('-') + 1)

        return (
            <Form onSubmit={handleSubmit}>
                {active || _.has(state, 'name') ?
                    <div style={{ width: '80%', margin: active == '一键清除' ? 'auto' : '20px auto' }}>{children}</div> :
                    <div style={{ width: '80%', margin: '60px auto', color: '#ccc' }}>
                        <Row>
                            <Col span={5}></Col>
                            <Col span={19}>请选择添加周期或已有周期</Col>
                        </Row>
                    </div>
                }

                <div style={{ textAlign: 'right', margin: '40px 50px 0px 0px' }}>
                    <Form.Item><br />
                        {
                            warnKey == 'warning' && currentValue?.current?.condition?.length == 0 ?
                                <>
                                    {['一键清除', '周期清除'].includes(active) || !active ? cleanAdd ? <HasPermission permission={cleanAdd}>
                                        <Popconfirm title="当前清除条件为空，将忽略确认及处理操作的状态，
                                            对满足其他条件的报警进行清除，为了防止出现失误，请谨慎操作！"
                                            overlayStyle={{ width: 300 }}
                                            onConfirm={handleSubmit} okText="确定" cancelText="取消"
                                        >
                                            <Button type="primary" loading={submitting} disabled={invalid}>确定</Button>
                                        </Popconfirm>
                                    </HasPermission> : null : cleanEdit ? <HasPermission permission={cleanEdit}>
                                        <Popconfirm title="当前清除条件为空，将忽略确认及处理操作的状态，
                                            对满足其他条件的报警进行清除，为了防止出现失误，请谨慎操作！"
                                            overlayStyle={{ width: 300 }}
                                            onConfirm={handleSubmit} okText="确定" cancelText="取消"
                                        >
                                            <Button type="primary" loading={submitting} disabled={invalid}>修改</Button>
                                        </Popconfirm>
                                    </HasPermission> : null
                                    }
                                </>
                                : <>
                                    {['一键清除', '周期清除'].includes(active) || !active ? cleanAdd ? <HasPermission permission={cleanAdd}>
                                        <Button type="primary" onClick={handleSubmit} loading={submitting} disabled={invalid}>
                                            确定
                                        </Button>
                                    </HasPermission> : null : cleanEdit ? <HasPermission permission={cleanEdit}>
                                        <Button type="primary" onClick={handleSubmit} loading={submitting} disabled={invalid}>
                                            修改
                                        </Button>
                                    </HasPermission> : null
                                    }
                                </>
                        }
                        <Button style={{ marginLeft: 15 }} onClick={() => { setActive('一键清除'); setType('一键清除'); setVisible(false); setState({}) }}>取消</Button>
                    </Form.Item>
                </div><br />
            </Form>
        )
    }

    const getCycles = () => {
        api({ name: url }).fetch('?query=' + JSON.stringify(query), {})
        .then(({ status, json }) => {
            if (status == 200) {
                setArr(json)
                setSearchArr(json)
            } else {
                // message.error(arg.message)
            }
        }).catch(err=>{
            message.error(err?.message,err?.detail)
        })
    }

    const onSearch = value => {
        setSearchArr([...arr].filter(item => item.name.indexOf(value.target.value) != -1))
    };
    const addPeriodic = () => {
        setState({
            name: null//moment(new Date()).format('YYYY-MM-DD_HH:mm:ss')
        })
        setActive(null)
    }
    const searchSelect = (id) => {
        setLoading(true)
        api({ name: url }).fetch('/' + id, {})
            .then(({ status, json }) => {
                setLoading(false)
                if (status == 200) {
                    json.cycle = {
                        cycle: json.cycle,
                        cycle_type: json.cycle_type
                    }
                    setState({ ...json })
                } else {
                    // message.error(arg)
                }
            }).catch(() => setLoading(false))
    }
    const remove = (i) => () => {
        setSearchArr([
            ...arr.slice(0, i),
            ...arr.slice(i + 1)
        ])
    }
    const onSubmit = (value) => {
        let val = _.cloneDeep(value)
        if (saveItem && _.isFunction(saveItem)) {
            const cb = () => {
                setState({})
                setActive('一键清除')
                setType('一键清除')
                setVisible(false)
            }
            saveItem(val, type, cb)
            return
        }
        let url = type == '一键清除' ? onceUrl : _url
        if (props?.btnModule == 'warning') {
            val.type = type == '一键清除' ? _.isArray(val.type) ? { "$in": val.type } : val.type : val.type
            if (val?.condition?.length) {
                // processed 处理  status确认
                if (val.condition.indexOf('已处理') > -1) val['processed'] = '已处理'
                if (val.condition.indexOf('已确认') > -1) val['status'] = '已确认'
            }
            if (type == '一键清除') {
                if (val?.model) { val['modelId'] = { '$in': val.model.map(item => item.id) } }
                if (val?.department) { val['departmentId'] = { '$in': val.department.map(item => item.id) } }
                if (val?.node) { val['nodeId'] = { '$in': val.node.map(item => item.id) } }
                if (val?.desc?.length) { val['desc'] = { '$in': val.desc.map(item => item.substr(item.lastIndexOf('-') + 1)) } } else { delete val.desc }
                if (val?.time) { val.time = { '$gte': val.time.gte, '$lte': val.time.lte } }
                delete val.condition
                // delete val.types
                delete val.department
                delete val.model
                delete val.range
                delete val.node
                val = { filter: { ...val } }
            }
        } else if (props?.btnModule == 'instruct') {
            // if (type == '一键清除') {
            //     if (val?.time) { val.time = { '$gte': val.time.gte, '$lte': val.time.lte } }
            //     val = { filter: { ...val } }
            // }
            if (type == '一键清除') {
                val = _.isObject(val.time) ? {
                    ...val,
                    time: {
                        $gte: val?.time?.start_time,
                        $lte: val?.time?.end_time
                    }
                } : { ...val, end_time: val.time }
                if (_.isEmpty(val.start_time)) delete val.start_time
                if (_.isEmpty(val.end_time)) delete val.end_time
                // delete val.types
            } else {
                val.disabled = _.isEmpty(val.disabled) ? false : val.disabled
            }
        } else {
            // val.type = val?.types
            if (type == '一键清除') {
                val = _.isObject(val.time) ? {
                    ...val,
                    time: {
                        $gte: val?.time?.start_time,
                        $lte: val?.time?.end_time
                    }
                } : { ...val, end_time: val.time }
                if (_.isEmpty(val.start_time)) delete val.start_time
                if (_.isEmpty(val.end_time)) delete val.end_time
                // delete val.types
            } else {
                val.disabled = _.isEmpty(val.disabled) ? false : val.disabled
            }
        }
        const bul = val.name !== active && !['一键清除', '周期清除'].includes(active)
        let logUrl = url + (!['一键清除'].includes(active) && active ? `/${bul ? active : val.name}` : '')
        let deviceUrl = url + (!['一键清除'].includes(active) && active ? `/${bul ? active : val.name}` : '')
        let warningUrl = url + (!['一键清除'].includes(active) && active ? `/${bul ? active : val.id}` : '')
        if (props?.btnModule == 'warning' && type == '一键清除') {
            const query = encodeURIComponent(JSON.stringify(val))
            api({ name: `${warningUrl}?query=${query}` }).fetch('', {}).then((arg) => {
                if (arg.status >= 200 && arg.status < 400) {
                    message.success('清除成功')
                    setState({})
                    setActive('一键清除')
                    setType('一键清除')
                    setVisible(false)
                    modelDispatch({ type: 'GET_ITEMS', filter: { ...stateFilter, skip: 0 } })
                } else {
                    message.error(arg.message,arg?.detail)
                }
            })
        } else {
            let fetchUrl;
            switch (props?.btnModule) {
                case 'warning':
                    fetchUrl = warningUrl
                    break;
                case 'instruct':
                    fetchUrl = deviceUrl
                    break;
                default:
                    fetchUrl = logUrl
                    break;
            }
            api({ name: fetchUrl }).fetch('', {
                method: ['一键清除', '周期清除'].includes(active) || !active ? 'POST' : 'PATCH',
                body: JSON.stringify({ ...val, ...val.cycle })
            }).then((arg) => {
                if (arg.status >= 200 && arg.status < 400) {
                    if(arg?.json && _.isString(arg.json)) {
                        message.success(arg.json)
                    } else {
                        message.success('保存成功！')
                    }
                    setState({})
                    setActive('一键清除')
                    setType('一键清除')
                    setVisible(false)
                    modelDispatch({ type: 'GET_ITEMS' })
                } else {
                    message.error(arg.message,arg?.detail)
                }
            }).catch(err => {
                message.error(err.message,err?.detail)
            })
        }
    }

    const clearForm = (
        <SchemaForm formkey={`ClearLogBtn-${props?.btnModule}`}
            key={`ClearLogBtn-${props?.btnModule}-${state.id || state.name}-${active}`}
            schema={type == '一键清除' ? onceSchema : cycleSchema}
            initialValues={state}
            component={props => <ChildrenNode {...props} currentValue={currentValue} setVisible={setVisible} btnModule={props?.btnModule} />}
            onSubmit={value => { onSubmit(value); currentValue.current = null }}
            onChange={value => currentValue.current = value}
        />
    )

    return (
        <Layout style={{ padding: 0, maxHeight: 550 }} className="warn-archive-model clear-model">
            <SchemaForm formkey={'test'}
                onChange={(arg) => {
                    setType(arg.clearType)
                    setActive(arg.clearType == '周期清除' ? null : arg.clearType)
                    if (arg.clearType == '一键清除') {
                        setState({})
                    } else {
                        getCycles()
                    }
                }}
                initialValues={{ clearType: type }}
                schema={{
                    type: 'object',
                    properties: {
                        clearType: {
                            type: 'string',
                            title: '清除方式',
                            enum: ['一键清除', '周期清除']
                        },
                    }
                }}
                component={({ children }) => <Form >
                    <div style={{ width: '80%', margin: 'auto' }}>{children}</div>
                </Form>}
            />
            {
                type == '一键清除' ? clearForm :
                    <>
                        <Layout style={{ padding: 0, borderTop: '1px solid #f0f0f0' }} className="clear-model">
                            {<Sider width={250} style={{ borderRight: '1px solid #f0f0f0', overflow: 'auto' }}>
                                <div style={style}>
                                    <span style={{ fontSize: 16, fontWeight: 500 }}>周期管理</span>
                                    <HasPermission permission={cleanAdd}>
                                        <Tooltip title='添加周期'>
                                            <Button type='primary' size='small' onClick={addPeriodic} style={{ position: 'absolute', right: 10 }} icon={<Icon type='plus' />} />
                                        </Tooltip>
                                    </HasPermission>
                                </div>
                                <div style={style}><Input placeholder="搜索..." onChange={onSearch} /></div>
                                <Menu mode="inline" selectedKeys={active} onSelect={(arg) => {
                                    setActive(arg.key);
                                    let id = arg.key
                                    if (props?.btnModule == 'warning' || queryKey == 'id') { id = arg?.item?.props?.id }
                                    searchSelect(id)
                                }}>
                                    {searchArr?.length ? searchArr.map((item, index) => <Menu.Item key={item.name} id={item.id}>
                                        <TableTile {...props} btnModule={props?.btnModule} title={item.name} remove={remove} index={index} data={item} setActive={setActive} setState={setState} setSearchArr={setSearchArr} getCycles={getCycles} />
                                    </Menu.Item>) : null}
                                </Menu>
                            </Sider>}
                            <Content style={{ padding: 10, overflow: 'auto' }}>
                                {loading ? <Loading>{clearForm}</Loading> : clearForm}
                            </Content>
                        </Layout>
                    </>
            }

        </Layout>
    )
}

const ClearLogBtn = (props) => {
    const { onChange, modelDispatch } = props
    const [visible, setVisible] = React.useState(false);
    const [active, setActive] = React.useState('一键清除')

    let title;
    switch (props?.btnModule) {
        case 'warning':
            title = '报警';
            break;
        case 'instruct':
            title = '指令日志';
            break;
        case 'flow':
            title = '实例';
            break;
        default:
            title = props.title || '日志';
            break;
    }

    // return React.useMemo(()=>{
    return <>
        <Modal destroyOnClose={true}
            maskClosable={false}
            keyboard={false}
            title={`清除${title}`}
            visible={visible}
            footer={[]}
            onCancel={() => { setActive('一键清除'); setVisible(false); }}
            // width={active == '一键清除' ? '40%' : '70%'}
            width={'60%'}

        >
            <Component {...props} onChange={(arg) => { onChange(arg) }} visible={visible} setVisible={setVisible} active={active} setActive={setActive} modelDispatch={modelDispatch} />
        </Modal>
        <Popconfirm placement="bottomRight"
            icon={null} title={`清除的${title}将无法恢复，确定进行清除操作`}
            onConfirm={() => setVisible(true)} >
            <Button>{`清除${title}`}</Button>
        </Popconfirm>

    </>
    // },[visible])
}

export default ClearLogBtn
